module.exports = __webpack_public_path__ + "static/media/appstore.62c83f5b.png";